export const COORDINATES_INITIAL_VIEW: [number, number, number, number] = [-140, 50, 120, 50];

export const COORDINATES_MARKERS = [
  {
    longitude: -100,
    latitude: 40,
    country: 'United States',
  },
  {
    longitude: 27.567444,
    latitude: 53.893009,
    country: 'Minsk, Belarus',
  },
  {
    longitude: 37.618423,
    latitude: 55.751244,
    country: 'Moscow, Russia',
  },
  {
    longitude: -0.118092,
    latitude: 51.509865,
    country: 'United Kingdom',
  },
];
